<template lang="pug">
	.audio-tracker-wapi-plugin-popup
		Popup(v-if="pluginVisible", ref="popup", :popupVisible="pluginVisible", classes="tracker-dark", :width="pluginUI.width || 780", :height="pluginUI.height || 520", :closeOnOutsideClick="false", @hiding="v => stop()")
			.content
				WAPIPlugin(v-if="pluginVisible", ref="plugin", :plugins="plugins", :tracker="tracker", :playing="isPlaying", :aggregatedTrack="aggregatedTrack", :source="source", :audioContext="audioContext", :pluginId="pluginId", :config="config", @playing="v => isPlaying = v")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="save")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="cancel")
			.flex-row.space.align-center(slot="actions-left")
				DxButton(v-if="!hidePlay", :text="!isPlaying ? $tCaption('Play', '@actions') : $tCaption('Stop', '@actions')", type="default", :icon="isPlaying ? 'square' : 'fas fa-play'", @click="togglePlay")
				DxButton(:text="$tCaption('Reset', '@actions')", type="normal", icon="refresh", @click="clearValues")
</template>

<script>	
	import VueTypes from 'vue-types';
	import Popup from 'app-core/Popup.vue';
	import WAPIPlugin from './WAPIPlugin.vue';
	import DxButton from 'devextreme-vue/button';
	import pluginsList from './plugins-list';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-wapi-plugin',
		components: { Popup, WAPIPlugin, DxButton },
		props: {
			plugins: VueTypes.any.def(null),
			source: VueTypes.any.def(null),
			audioContext: VueTypes.any.def(null),
			playing: VueTypes.bool.def(false),
			tracker: VueTypes.any.def(null),
			hidePlay: VueTypes.bool.def(false)
		},
		data() {
			return {
				pluginVisible: false,
				pluginId: null,
				config: null,
				pluginItem: null,
				plugin: null,
				pluginUI: null,
				isPlaying: this.playing,
				aggregatedTrack: null
			}
		},
		watch: {
			playing(v) {
				this.isPlaying = v;
			}
		},	
		mounted() {
			if (__DEBUG__)
				window.wapiPluginPopup = this;
		},
		methods: {
			async showPopup(pluginId, pluginData, instanceId, aggregatedTrack) {
				if (__DEBUG__)
					console.debug('Show popup', { pluginId, pluginData, aggregatedTrack });
				this.aggregatedTrack = aggregatedTrack;
				this.pluginVisible = false;
				this.pluginItem = pluginsList.getPluginItem(pluginId);
				this.plugin = await pluginsList.getPlugin(pluginId);
				this.pluginUI = this.plugin.instance.getUI();
				this.isPlaying = this.playing;
				if (__DEBUG__)
					window.wapiPluginPopup = this;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.pluginId = pluginId;
					let trackPluginData = this.plugins?.find(f => f.instanceId && f.instanceId === instanceId);
					if (!trackPluginData)
						trackPluginData = this.plugins?.find(f => f.id === pluginId);
					this.config = pluginData || trackPluginData || {};
					this.pluginVisible = true;
				});
			},
			togglePlay() {
				this.$refs.plugin?.togglePlay();
			},
			stop() {
				this.$refs.plugin?.stop();
			},
			save() {
				this.$refs.plugin?.save();
				if (this.$refs.plugin?.playInitialized)
					this.stop();
				this.$refs.plugin?.deactivatePlugin();
				this.pluginVisible = false;
				this.$emit('save');
			},
			clearValues() {
				this.$refs.plugin?.clearValues();
				if (this.$refs.plugin?.$refs?.cmp?.clearValues) {
					this.$refs.plugin?.$refs?.cmp?.clearValues();
				}
			},
			cancel() {
				if (this.$refs.plugin?.playInitialized)
					this.stop();
				this.$refs.plugin?.deactivatePlugin();
				this.tracker.refreshPlay();
				this.$refs.plugin?.cancel();
				this.pluginVisible = false;
				this.$emit('cancel');
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-wapi-plugin {
		@import "main/themes/generated/variables.base.scss";
	}
</style>
